import { useState } from 'react';
import emailjs from '@emailjs/browser';

function ContactPage() {
  const [status, setStatus] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    try {
      setStatus('Sending...');
      // Replace with your EmailJS IDs
      await emailjs.sendForm(
        'service_v9cxblw',
        'template_4xh113p',
        form,
        { publicKey: 'TPEA6h8yz0pbLO7Ul' },
      );
      setStatus('Message sent successfully!');
      form.reset();
    } catch (err) {
      setStatus('Failed to send. Please try again.');
    }
  };

  return (
    <div className="max-w-xl">
      <h2 className="text-2xl font-semibold mb-4">Contact</h2>
      <form onSubmit={onSubmit} className="space-y-4">
        <input name="user_name" placeholder="Your name" required className="w-full px-4 py-2 rounded-lg bg-white/5 border border-white/10" />
        <input type="email" name="user_email" placeholder="Your email" required className="w-full px-4 py-2 rounded-lg bg-white/5 border border-white/10" />
        <textarea name="message" placeholder="Your message" rows="5" required className="w-full px-4 py-2 rounded-lg bg-white/5 border border-white/10" />
        <button type="submit" className="px-5 py-2.5 rounded-lg bg-primary text-primary-foreground">Send</button>
      </form>
      <p className="text-sm mt-3 text-foreground/80">{status}</p>
      <div className="mt-6 flex gap-4 text-foreground/80">
        <a className="hover:text-accent" href="mailto:you@example.com">Email</a>
        <a className="hover:text-accent" href="https://github.com/your-github" target="_blank" rel="noreferrer">GitHub</a>
        <a className="hover:text-accent" href="https://www.linkedin.com/in/your-linkedin" target="_blank" rel="noreferrer">LinkedIn</a>
      </div>
    </div>
  );
}

export default ContactPage;


